/** @format */
import { getAccess, dataUtils } from '@/components/mixings';

import axios from '../../libs/axios';
const state = {
  keys: {},
  badges: {
    tasks: { comments: 0, items: 0 },
    tasksgoods: { comments: 0, items: 0 },
    finance: { comments: 0, items: 0 },
    payorder: { new: 0, plan: 0, late: 0 },
    changeLog: { new: 0 },
  },
  refreshMap: {},
  newComment: 0,
};

const getters = {
  getKeys: (state) => state.keys,
  getBadges:
    (state) =>
    (name = null, type = null) => {
      if (!name && !type) return state.badges;
      return state.badges?.[name]?.[type];
    },
  getNewComment: (state, name) => {
    return state.newComment;
  },

  profile: (state, getters, rootState) => {
    return rootState.auth.profile;
  },
};

const actions = {
  keys: async ({ state, commit, dispatch }, data) => {
    let keys = state.keys;
    for (const [key, value] of Object.entries(data)) {
      keys[key] = value;
    }
    commit('setKeys', keys);
  },
  async badges({ state, commit, dispatch, rootState }, data) {
    let badges = state.badges;
    if ((rootState.auth.profile?.role || 0) < 20) {
      return;
    }
    let a = rootState?.config?.data?.config?.access || {};
    const user = rootState.auth.profile.id;
    const role = rootState.auth.profile.role;
    let params = {};
    if (data == 'payorder' || !data) {
      if (getAccess.methods.getAccess2({ access: a, name: 'menu.payOrder', role, user })) {
        let api = '/report_sql';
        const access = dataUtils.methods.getObjectPath(a, 'payOrder.viewAll') || {};
        let isAdmin = 0;
        if (getAccess.methods.checkAccess(access, {}, role, user, false)) isAdmin = 1;
        axios.post(api, { name: 'getPayOrderCount', params: { type: 'new', isAdmin } }).then((resp) => {
          if (resp.data.status === 'ok') {
            badges.payorder.new = resp.data.data?.[0]?.count || 0;
          }
        });
        axios.post(api, { name: 'getPayOrderCount', params: { type: 'plan', isAdmin } }).then((resp) => {
          if (resp.data.status === 'ok') {
            badges.payorder.plan = resp.data.data?.[0]?.count || 0;
          }
        });
        axios.post(api, { name: 'getPayOrderCount', params: { type: 'late', isAdmin } }).then((resp) => {
          if (resp.data.status === 'ok') {
            badges.payorder.late = resp.data.data?.[0]?.count || 0;
          }
        });
      }
    }
    if (data == 'changeLog' || !data)
      axios.get('/mechti/change_log/count_unviewed').then((resp) => {
        if (resp.data.status === 'ok') {
          badges.changeLog.new = resp.data.data;
        }
      });
    params = { filters: { type: { condition: '<>', value: 'construction-goods' } } };
    if (data == 'task' || data == 'task_comments' || !data)
      axios.get('/mechti/tasks/count_unviewed_comments', { params }).then((resp) => {
        if (resp.data.status === 'ok') {
          badges.tasks.comments = resp.data.data;
        }
      });
    if (data == 'task' || data == 'task_items' || !data)
      axios.get('/mechti/tasks/count_unviewed', { params }).then((resp) => {
        if (resp.data.status === 'ok') {
          badges.tasks.items = resp.data.data;
        }
      });
    params = { filters: { type: 'construction-goods' } };
    if (getAccess.methods.getAccess2({ access: a, name: 'menu.tasks-goods', role, user })) {
      if (data == 'buying' || data == 'buying_comments' || !data)
        axios.get('/mechti/buying/count_unviewed_comments', {}).then((resp) => {
          if (resp.data.status === 'ok') {
            badges.tasksgoods.comments = resp.data.data;
          }
        });
      if (data == 'buying' || data == 'buying_items' || !data)
        axios.get('/mechti/buying/count_unviewed', {}).then((resp) => {
          if (resp.data.status === 'ok') {
            badges.tasksgoods.items = resp.data.data;
          }
        });
    }
    if (false)
      if (data == 'finance_items' || !data)
        axios.get('/mechti/finance/count_unviewed').then((resp) => {
          if (resp.data.status === 'ok') {
            badges.finance.items = resp.data.data;
          }
        });

    if (data == 'task_comments') commit('setNewComments');
    commit('setBadges', badges);
  },
  newComment({ commit }, data) {
    commit('setNewComment');
  },
};

const mutations = {
  setKeys: (state, keys) => {
    console.log('state', keys);
    state.keys = keys;
  },
  setBadges: (state, badges) => {
    state.badges = badges;
  },
  setNewComment: (state) => {
    state.newComment++;
  },
  TRIGGER_REFRESH(state, target) {
    state.refreshMap = {
      ...state.refreshMap,
      [target]: Date.now(),
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
